import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LoginService } from "../service/login.service";
import { Subscription } from "rxjs";
import { ProgressBar } from "primeng/progressbar";
import { LoginPageComponent } from "../login-page/login-page.component";

@Component({
	selector: "app-login-sso",
	templateUrl: "./login-sso.component.html",
	imports: [ProgressBar, LoginPageComponent]
})
export class LoginSsoComponent implements OnInit, OnDestroy {
	private readonly loginService = inject(LoginService);

	private readonly router = inject(Router);
	private readonly route = inject(ActivatedRoute);

	failed = false;

	private routeSub?: Subscription;

	ngOnInit() {
		this.routeSub = this.route.queryParams.subscribe({
			next: params => {
				const code = params["code"];
				const returnUrl = sessionStorage.getItem("returnUrl") || "/admin";

				if (code) {
					this.loginService.doLoginSso(code).subscribe({
						next: result => {
							if (result.idToken) localStorage.setItem("id_token", result.idToken);
							if (result.accessToken) localStorage.setItem("access_token", result.accessToken);
							if (result.refreshToken) localStorage.setItem("refresh_token", result.refreshToken);

							this.router
								.navigateByUrl(returnUrl)
								.then(() => sessionStorage.removeItem("returnUrl"));
						},
						error: () => (this.failed = true)
					});
				} else this.failed = true;
			}
		});
	}

	ngOnDestroy() {
		this.routeSub?.unsubscribe();
	}
}
